import { useNavigate } from "@solidjs/router";

export default function Header() {
  const nav = useNavigate();

  return (
    <div id="interview-header">
      <div class="logo-container">
        <h1
          style={{ cursor: "pointer", width: "fit-content" }}
          onClick={() => {
            nav("/home");
          }}>
          mia
        </h1>
      </div>
    </div>
  );
}
